export const ANOMALY = {
    DETECTED: "detected",
    NOT_DETECTED: "not_detected"
};

export const TECHNICAL_GUIDE_STATE = {
    NONE: "none",
    HELPFUL: "helpful",
    NOT_HELPFUL: "not_helpful"
};

export const PAUSE_REQUEST = {
    NONE: "none",
    DAYS_7: "7_days",
    DAYS_14: "14_days",
    DAYS_30: "30_days",
    DAYS_90: "90_days"
};

export const FIRST_QUESTION_KEY = "anomaly";
export const TECHNICAL_GUIDE_LINKED = "technicalGuideLinked";
export const FOLLOWUP_QUESTION = "followupQuestion"; // this is used for a value that is only used to trigger a follow-up question
